/**
 * abilityVfxBrand — Brand Q/W/E/R fire silhouettes (SPY-212).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildSear(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const fire = mat(THREE, spec.color || 0xea580c);
  const ember = mat(THREE, 0xfbbf24);
  const orb = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), fire);
  orb.position.y = 0.45 * s;
  group.add(orb);
  const trail = new THREE.Mesh(new THREE.ConeGeometry(0.14 * s, 0.7 * s, 6), ember);
  trail.position.set(0, 0.35 * s, -0.35 * s);
  trail.rotation.x = Math.PI / 2;
  group.add(trail);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), ember);
  spark.position.set(0.25 * s, 0.6 * s, 0);
  group.add(spark);
  group.userData = { shape: 'sear' };
  return group;
}

export function buildPillarOfFlame(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.7);
  const fire = mat(THREE, spec.color || 0xdc2626, 0.88);
  const rim = mat(THREE, 0xf97316, 0.8);
  const pillar = new THREE.Mesh(new THREE.CylinderGeometry(0.2 * s, 0.35 * s, 1.4 * s, 10), fire);
  pillar.position.y = 0.75 * s;
  group.add(pillar);
  const base = new THREE.Mesh(
    new THREE.RingGeometry(0.3 * s, 0.7 * s, 20).rotateX(-Math.PI / 2),
    rim
  );
  base.position.y = 0.05;
  group.add(base);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.22 * s, 0.45 * s, 8), rim);
  tip.position.y = 1.55 * s;
  group.add(tip);
  group.userData = { shape: 'pillar_of_flame' };
  return group;
}

export function buildConflagration(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.2);
  const fire = mat(THREE, spec.color || 0xf97316);
  const dark = mat(THREE, 0x7c2d12);
  for (let i = 0; i < 3; i += 1) {
    const blob = new THREE.Mesh(new THREE.SphereGeometry(0.18 * s, 8, 8), fire);
    const a = (Math.PI * 2 * i) / 3;
    blob.position.set(Math.cos(a) * 0.35 * s, 0.4 * s, Math.sin(a) * 0.35 * s);
    group.add(blob);
  }
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.2 * s, 10, 10), dark);
  core.position.y = 0.4 * s;
  group.add(core);
  group.userData = { shape: 'conflagration' };
  return group;
}

export function buildPyroclasm(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.6);
  const fire = mat(THREE, spec.color || 0xb91c1c, 0.9);
  const hot = mat(THREE, 0xfde047, 0.85);
  const hub = new THREE.Mesh(new THREE.SphereGeometry(0.3 * s, 12, 12), fire);
  hub.position.y = 0.55 * s;
  group.add(hub);
  const arm = new THREE.Mesh(new THREE.BoxGeometry(1.2 * s, 0.12 * s, 0.12 * s), hot);
  arm.position.y = 0.55 * s;
  group.add(arm);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.75 * s, 20).rotateX(-Math.PI / 2),
    fire
  );
  ring.position.y = 0.06;
  group.add(ring);
  group.userData = { shape: 'pyroclasm' };
  return group;
}
